export default __webpack_public_path__ + "static/media/leftWhiteArrow.3eddfaf6.svg";